import axios from "axios";

export default function sendNotification(data) {
    axios.post('/notification/send-custom', data).then(() => {
        // console.log('object')
    }).catch(e => {
        console.log(e)
    })
}